import { Component, Input } from '@angular/core';

@Component({
    selector: 'dp-trk-status',
    templateUrl: './status.component.html',
    styleUrls: ['./status.component.scss']
})
export class StatusComponent {
    @Input() public title: string;
    @Input() public type = 'success';
    @Input() public index: string | number;
    @Input() public active = false;
    @Input() public first = false;
    @Input() public last = false;
}
